import React from 'react';
import { Crown, Star, Phone, Mail } from 'lucide-react';
import { isVipActive, formatVipExpiry } from '../constants';

const InfoTab = ({ customer, isAdmin, onOpenVip, onOpenAgent }) => {
  return (
    <div className="space-y-4">
      {/* VIP */}
      {isVipActive(customer) ? (
        <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-yellow-800 flex items-center gap-1">
                <Crown className="w-4 h-4" />VIP 会员
              </p>
              <p className="text-xs text-yellow-600 mt-1">到期时间：{formatVipExpiry(customer)}</p>
            </div>
            {isAdmin && (
              <div className="flex gap-2">
                <button onClick={() => onOpenVip('renew')}
                  className="text-xs px-3 py-1.5 bg-yellow-100 text-yellow-700 rounded-lg hover:bg-yellow-200">
                  续费
                </button>
                <button onClick={() => onOpenVip('cancel')}
                  className="text-xs px-3 py-1.5 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200">
                  取消
                </button>
              </div>
            )}
          </div>
        </div>
      ) : (
        isAdmin && (
          <button onClick={() => onOpenVip('open')}
            className="w-full py-2 border-2 border-dashed border-yellow-300 text-yellow-600 rounded-xl text-sm hover:bg-yellow-50 flex items-center justify-center gap-2">
            <Crown className="w-4 h-4" />开通 VIP 会员
          </button>
        )
      )}

      {/* 代理 */}
      {isAdmin && (
        <div className={`border rounded-xl p-4 ${customer.is_agent ? 'bg-purple-50 border-purple-200' : 'border-gray-200'}`}>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium flex items-center gap-1 text-purple-800">
                <Star className="w-4 h-4" />代理
              </p>
              {customer.is_agent === 1 ? (
                <>
                  <p className="text-xs text-purple-600 mt-1">
                    优惠码：<span className="font-mono font-bold">{customer.agent_code}</span>
                  </p>
                  <p className="text-xs text-purple-600">
                    分成比例：{customer.agent_commission_rate}% | 累计佣金：${parseFloat(customer.agent_total_earnings || 0).toFixed(2)} | 推广次数：{customer.agent_total_referrals || 0}
                  </p>
                </>
              ) : (
                <p className="text-xs text-gray-400 mt-1">未开通代理</p>
              )}
            </div>
            <button onClick={onOpenAgent}
              className={`text-xs px-3 py-1.5 rounded-lg ${
                customer.is_agent
                  ? 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  : 'bg-purple-100 text-purple-700 hover:bg-purple-200'
              }`}>
              {customer.is_agent ? '取消' : '开通'}
            </button>
          </div>
        </div>
      )}

      {/* 账号信息 */}
      <div className="bg-gray-50 rounded-xl p-4 space-y-2">
        <p className="text-sm font-medium text-gray-700 mb-2">账号信息</p>
        {customer.phone && (
          <div className="flex items-center space-x-2 text-sm">
            <Phone className="w-4 h-4 text-gray-400" />
            <span>{customer.phone}</span>
          </div>
        )}
        {customer.email && (
          <div className="flex items-center space-x-2 text-sm">
            <Mail className="w-4 h-4 text-gray-400" />
            <span>{customer.email}</span>
            <span className="text-xs text-green-500">已绑定</span>
          </div>
        )}
        {customer.tg_username && (
          <div className="flex items-center space-x-2 text-sm">
            <span className="text-blue-500">✈️</span>
            <span>@{customer.tg_username}</span>
            <span className="text-xs text-green-500">已绑定</span>
          </div>
        )}
      </div>

      {/* 消费统计 */}
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-blue-50 rounded-xl p-4 text-center">
          <p className="text-2xl font-bold text-blue-600">{customer.order_count || 0}</p>
          <p className="text-xs text-gray-500 mt-1">累计订单</p>
        </div>
        <div className="bg-green-50 rounded-xl p-4 text-center">
          <p className="text-2xl font-bold text-green-600">${parseFloat(customer.total_spent || 0).toFixed(2)}</p>
          <p className="text-xs text-gray-500 mt-1">累计消费</p>
        </div>
      </div>

      {/* 最近订单 */}
      {customer.recent_orders?.length > 0 && (
        <div>
          <p className="text-sm font-medium text-gray-700 mb-2">最近订单</p>
          <div className="space-y-2">
            {customer.recent_orders.map(order => (
              <div key={order.id} className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
                <div>
                  <p className="text-sm font-medium">{order.order_no}</p>
                  <p className="text-xs text-gray-400">{new Date(order.created_at).toLocaleDateString('zh-CN')}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-medium text-green-600">${parseFloat(order.total_amount).toFixed(2)}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoTab;